module.exports = __webpack_public_path__ + "img/gift4-01-c05-t1.832355d3.png";